/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CampaignListEntryFromJSON, CampaignListEntryToJSON, } from './';
export function CampaignWrapperListEntryFromJSON(json) {
    return CampaignWrapperListEntryFromJSONTyped(json, false);
}
export function CampaignWrapperListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'campaigns': !exists(json, 'campaigns') ? undefined : (json['campaigns'].map(CampaignListEntryFromJSON))
    };
}
export function CampaignWrapperListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'organisationId': value.organisationId,
        'userId': value.userId,
        'campaigns': value.campaigns === undefined ? undefined : (value.campaigns.map(CampaignListEntryToJSON))
    };
}
